import { createContext } from "react";

const ServiceContext = createContext();

export default ServiceContext;